import { render, staticRenderFns } from "./AddRecipient.vue?vue&type=template&id=3422b4b0&scoped=true&"
import script from "./AddRecipient.vue?vue&type=script&lang=js&"
export * from "./AddRecipient.vue?vue&type=script&lang=js&"
import style0 from "./AddRecipient.vue?vue&type=style&index=0&id=3422b4b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3422b4b0",
  null
  
)

component.options.__file = "AddRecipient.vue"
export default component.exports